import i18n from 'i18n';
import * as React from 'react';
import { Button, Divider, Form, Header, Icon, Popup, Segment } from 'semantic-ui-react';
import { isNullOrWhiteSpaces } from 'utils/useful-functions';

interface ITextBoxFilterProps {
  triggerTitle: string;
  filterTitle: string;
  onFilter: (value: string) => void;
  onClear: () => void;
  size?: 'mini' | 'tiny' | 'small' | 'large' | 'huge';
  position?: 'top left' | 'top right' | 'bottom right' | 'bottom left' | 'right center' | 'left center' | 'top center' | 'bottom center';
  on?: 'hover' | 'click' | 'focus' | ('hover' | 'click' | 'focus')[];
  active?: boolean;
  onActivate?: (visible: boolean) => void;
}

interface ITextBoxFilterState {
  visible: boolean;
  filtered: boolean;
  value: string;
}

export class TextBoxFilter extends React.Component<ITextBoxFilterProps, ITextBoxFilterState> {
  constructor(props: ITextBoxFilterProps) {
    super(props);
    this.state = {
      visible: false,
      filtered: this.props.active,
      value: ''
    };
  }

  UNSAFE_componentWillReceiveProps(next) {
    if (next !== this.props && next.active !== this.state.filtered) {
      if (next.active) {
        this.setState({ filtered: true });
      } else {
        this.setState({ filtered: false, visible: false, value: '' });
        this.props.onActivate && this.props.onActivate(false);
      }
    }
  }

  private onChange = (e, { value }) => {
    this.setState({ value });
  };

  private onFilter = e => {
    e.preventDefault();
    if (this.props.onFilter) {
      this.props.onFilter(this.state.value);
    }
    this.setState({ filtered: true, visible: false });
    this.props.onActivate && this.props.onActivate(false);
  };

  private onClear = () => {
    if (this.props.onClear) {
      this.props.onClear();
    }
    this.setState({ visible: false, filtered: false, value: '' });
    this.props.onActivate && this.props.onActivate(false);
  };

  private onClose = () => {
    this.setState({ visible: false });
    this.props.onActivate && this.props.onActivate(false);
  };

  private onOpen = e => {
    e.preventDefault();
    this.setState({ visible: true });
    this.props.onActivate && this.props.onActivate(true);
  };

  render() {
    const { filterTitle, triggerTitle, size, position, on } = this.props;
    const { visible, filtered, value } = this.state;

    return (
      <Popup
        open={visible}
        trigger={
          <a
            href="!#"
            onClick={this.onOpen}
            onKeyPress={e => e.key === 'Enter' && e.preventDefault()}
            onKeyDown={e => e.key === 'Enter' && e.preventDefault()}
          >
            {triggerTitle}&nbsp;
            <Icon name="filter" size="small" disabled={!filtered} />
          </a>
        }
        content={
          <Segment size="mini" basic className="textbox-filter">
            <Header as="h4">{filterTitle}</Header>
            <Divider />
            <Form size="tiny">
              <Form.Input
                placeholder={String(i18n.t('Type here'))}
                action={{ icon: 'filter', onClick: this.onFilter, disabled: isNullOrWhiteSpaces(value), size: 'tiny' }}
                size="mini"
                onChange={this.onChange}
                value={value}
              />
            </Form>
            <Divider />
            <Button size="tiny" compact onClick={this.onClear}>
              <Icon name="times" /> {String(i18n.t('Clear'))}
            </Button>
          </Segment>
        }
        on={on || 'click'}
        position={position || 'bottom left'}
        size={size || 'mini'}
        onClose={this.onClose}
      />
    );
  }
}
